import { DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { registerLocaleData, CurrencyPipe } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import localeSvExtra from '@angular/common/locales/extra/sv';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NewVersionNoticeComponent } from './components/new-version-notice/new-version-notice.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { ErrorHandlerService } from './logging/error.handler.service';
import { AuthInterceptor } from './services/auth.interceptor';

registerLocaleData(localeSv, 'sv', localeSvExtra);

// Only the shell is declared here; every page is a standalone component loaded by the router (app-routing.module.ts)
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, ToastContainerComponent, NewVersionNoticeComponent],
  providers: [
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'SEK' },
    { provide: LOCALE_ID, useValue: 'sv' },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    CurrencyPipe,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
